export default __webpack_public_path__ + "static/media/Engaging_result_01.be95bc70.png";